(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/index.js');
"use strict";


const BingoRouter = svs.bingo_react.BingoRouter;
const isUnderMaintenance = svs.bingo_react.data.maintenance.isUnderMaintenance;
const Maintenance = svs.bingo_react.pages.Maintenance;
ReactDOM.render(isUnderMaintenance ? React.createElement(Maintenance, null) : React.createElement(BingoRouter, null), document.getElementById('bingo-react-container'));

 })(window);